<script setup lang="ts">
import {
  PhArrowRight as ArrowRight,
  PhDownloadSimple as DownloadSimple,
  PhShieldCheck as ShieldCheck,
  PhUserFocus as UserFocus,
} from "@phosphor-icons/vue";
import { computed, ref } from "vue";
import BrandBar from "./BrandBar.vue";
import HomeButton from "./HomeButton.vue";
import IdentityCard from "./IdentityCard.vue";
import WorkhorseIdentityCard from "./WorkhorseIdentityCard.vue";
import { personalityAnalyses, results, workhorseIdentities } from "../data/content";
import { useSessionStore } from "../stores/session";

const store = useSessionStore();
const scoring = computed(() => store.result!);
const definition = computed(() => results[scoring.value.resultCode]);
const personalityAnalysis = computed(() => personalityAnalyses[scoring.value.resultCode]);
const workhorseIdentity = computed(() => workhorseIdentities[scoring.value.resultCode]);
const analysisOpen = ref(false);

const roleTheme = computed(() => ({
  "--poster-accent": definition.value.poster.accent,
  "--poster-soft": definition.value.poster.soft,
  "--poster-foreground": definition.value.poster.foreground,
}));

function openPoster() {
  store.track("poster_view", { result_code: scoring.value.resultCode });
  store.go("poster");
}

function openStatePath() {
  store.track("state_path_click", { result_code: scoring.value.resultCode });
  store.go("state");
}

function toggleAnalysis() {
  analysisOpen.value = !analysisOpen.value;
}

function collapseAnalysisFromBody() {
  if (analysisOpen.value) analysisOpen.value = false;
}
</script>

<template>
  <section class="screen screen--result result-redesign" :style="roleTheme">
    <div class="home-topline">
      <BrandBar label="你的牛马角色结果" />
      <HomeButton />
    </div>

    <IdentityCard :definition="definition" />

    <section class="result-copy-panel result-copy-panel--redesign">
      <details class="result-note result-note--personality result-analysis" :open="analysisOpen" @click="collapseAnalysisFromBody">
        <summary @click.stop.prevent="toggleAnalysis">
          <UserFocus :size="24" weight="fill" />
          <span>
            <strong>深入分析</strong>
            <p class="result-analysis__preview">{{ personalityAnalysis.full }}</p>
            <small class="result-analysis__collapsed-hint">点击查看完整解析</small>
          </span>
        </summary>
        <div class="result-analysis-sections">
          <section>
            <p>{{ personalityAnalysis.full }}</p>
          </section>
          <small class="result-analysis__expanded-hint">点击收起完整解析</small>
        </div>
      </details>
      <WorkhorseIdentityCard :identity="workhorseIdentity" />
      <div class="result-primary-paths" aria-label="结果页下一步">
        <button class="button button--primary result-poster-cta" @click="openPoster">
          生成我的牛马身份证 <DownloadSimple :size="21" weight="bold" />
        </button>
        <button class="button result-recovery-cta" @click="openStatePath">
          看看我现在最该先回血哪一块 <ArrowRight :size="20" weight="bold" />
        </button>
      </div>
    </section>

    <div class="result-actions result-actions--redesign">
      <button class="text-button" @click="store.restart">重新测试</button>
    </div>

    <p class="compliance-static"><ShieldCheck :size="16" weight="fill" /> NBTI 只描述娱乐化职场行为倾向，不构成医学、心理学、职业能力或中医体质诊断。</p>
  </section>
</template>
